const initialState = {
  selectedServer: null,
  serversList : []
}

export const servers = (state = initialState, action) => {
  switch (action.type) {
    case 'SETUP_SELECT_SERVER': {
      return {
        ...state,
        selectedServer: action.server
      };
    }
    case 'SETUP_UNSELECT_SERVER': {
      var tempArray = [...state.serversList];
      const index = tempArray.findIndex((s) => s.id === action.server);
      tempArray[index].selected = false;
      return {
        selectServer: null,
        serversList: tempArray
      }
    }
    case 'SET_SERVERS': {
      const index = action.servers.findIndex((s) => s.selected === true);
      var selectServer = false;
      if (index > -1) selectServer = action.servers[index].id;
      return {
        selectedServer: selectServer,
        serversList: action.servers
      };
    }
    case 'SETUP_DELETE_SERVER': {
      const index = state.serversList.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = [...state.serversList];
      tempArray.splice(index, 1);
      return {
        selectedServer: state.selectedServer === action.id ? null : state.selectedServer,
        serversList: tempArray
      };
    }
    default:
      return state;
  }
};
